<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">센터관리</span>
            <span class="txt">센터의 이름, 주소, 전화번호 등 센터의 기본정보를 설정합니다.</span>
        </div>

        <div class="com-table-content">
            <div class="com-btn-area">
                <div class="left-box">
                    <span class="tit">나의센터목록</span>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 215px" />
                    <col style="width: 240px" />
                    <col style="width: 240px" />
                    <col style="width: 540px" />
                    <col style="width: 145px" />
                    <col style="width: 160px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>센터명</th>
                        <th>센터로고</th>
                        <th>전화번호</th>
                        <th>주소</th>
                        <th>센터구분</th>
                        <th>등록일</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in data" :key="index">
                        <td>
                            <router-link
                                :to="{ name: 'SettingCenterEdit', params: { centerId: item.id } }"
                                class="link"
                            >
                                {{ item.centerName }}
                            </router-link>
                            <a class="link" href="#"></a>
                        </td>
                        <td>
                            <span class="logo-img">
                                <img v-if="item.logoUrl" :src="item.logoUrl" alt="" />
                                <span v-else>이미지 준비중</span>
                            </span>
                        </td>
                        <td>{{ item.telNo }}</td>
                        <td>{{ item.address }}</td>
                        <td>{{ item.centerType == 'M' ? '본점' : '지점' }}</td>
                        <td>{{ item.info.createdAt | timestampFilter }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <loading-spinner v-if="isLoading"></loading-spinner>

        <!--
        <b-pagination
            aria-controls="my-table"
            align="center"
            first-class="first"
            prev-class="prev"
            next-class="next"
            last-class="last"
            v-model="pagingInfo.page"
            :total-rows="pagingInfo.totalItems"
            :per-page="pagingInfo.limit"
            @change="handlerPagenation($event)"
        ></b-pagination>
        -->
    </div>
</template>

<script>
import api from '../../../assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { pagingInfo } from '@/assets/js/common';

export default {
    name: 'SettingCenterList',
    components: { LoadingSpinner },
    props: {},
    computed: {},
    data() {
        return {
            centerId: '',
            isLoading: false,
            data: {},
            pagingInfo: { ...pagingInfo },
        };
    },
    beforeMount() {
        this.centerId =
            (this.$store.state.auth.user || {}).centerId ||
            (this.$router.push({ name: 'login', query: { returnPathName: this.$route.name } }) && false);
    },
    mounted() {
        this.pagingInfo.page = this.$route.query.page || 1;
        this.load();
    },
    methods: {
        load() {
            this.isLoading = true;
            const url = `/admin/api/center/${this.centerId}/chain`;

            // @TODO: 권한에 따라, 최고권한이 아닌 경우는 자신의 목록만 볼 수 있다.
            //
            api.get(url, {
                // params: this.pagingInfo,
            })
                .then((res) => {
                    const { data } = res;

                    this.isLoading = false;
                    // this.setPageParams(res.data);
                    this.data = data;

                    // 바로 센터 기본정보 페이지로 이동
                    if (data.length === 1) {
                        this.$router.push({ name: 'SettingCenterEdit', params: { centerId: data[0].id } });
                    }
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.response.data.message}`);
                    console.error(res);
                });
        },
        /*
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 페이지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.load();
        },
         */
    },
};
</script>
<style lang="scss"></style>
